import './MainContent.css';
import ConjugationTable from './conjugation/ConjugationTable';
import Dictionary from './Dictionary';
import Search from './search/Search';
import API_SERVICE from '../utils/apiService';
import { useState } from 'react';
import { CONJUGATION_EXAMPLE } from '../utils/constants';


function MainContent() {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState(CONJUGATION_EXAMPLE);

  const handleSearch = async (text) => {
    try {
      const data = await API_SERVICE.fetchConjugations(text);
      setSearchResults(data);
    } catch (err) {
      console.log("some error occurred. need to figure out how to handle this properly.");
    }
  }

  return (
    <div className="main__content">
      <Search searchText={searchText} setSearchText={setSearchText} onSearch={handleSearch} />
      <Dictionary conjugation={searchResults} />
      <ConjugationTable
        conjugation={searchResults}
        title="Indicative"
        tensesToShow={[
          {
            "mood": "Indicative",
            "tense": "Present",
          },
          {
            "mood": "Indicative",
            "tense": "Imperfect",
          },
          {
            "mood": "Indicative",
            "tense": "Preterite",
          },
          {
            "mood": "Indicative",
            "tense": "Future",
          },
          {
            "mood": "Indicative",
            "tense": "Conditional",
          },
        ]}
      />
      <ConjugationTable
        conjugation={searchResults}
        title="Indicative"
        tensesToShow={[
          {
            "mood": "Indicative",
            "tense": "Present Perfect",
          },
          {
            "mood": "Indicative",
            "tense": "Past Perfect",
          },
          {
            "mood": "Indicative",
            "tense": "Preterite (Archaic)",
          },
          {
            "mood": "Indicative",
            "tense": "Future Perfect",
          },
          {
            "mood": "Indicative",
            "tense": "Conditional Perfect",
          },
        ]}
      />
      <ConjugationTable
        conjugation={searchResults}
        title="Subjunctive"
        tensesToShow={[
          {
            "mood": "Subjunctive",
            "tense": "Present",
          },
          {
            "mood": "Subjunctive",
            "tense": "Imperfect",
          },
          {
            "mood": "Subjunctive",
            "tense": "Future",
          },
        ]}
      />
      <ConjugationTable
        conjugation={searchResults}
        title="Subjunctive"
        tensesToShow={[
          {
            "mood": "Subjunctive",
            "tense": "Present Perfect",
          },
          {
            "mood": "Subjunctive",
            "tense": "Past Perfect",
          },
          {
            "mood": "Subjunctive",
            "tense": "Future Perfect",
          },
        ]}
      />
      <ConjugationTable
        conjugation={searchResults}
        title="Imperative"
        tensesToShow={[
          {
            "mood": "Imperative Affirmative",
            "tense": "Present",
          },
          {
            "mood": "Imperative Negative",
            "tense": "Present",
          },
        ]}
      />
    </div>
  );
}

export default MainContent;
